<div data-cy="no_action_page">
  <section class="layout-content mt">
    <assessment-text-desc></assessment-text-desc>
  </section>
  <assessment-result subTitle="NO_ACTION_TITLE"
                     subDesc="NO_ACTION_DESCRIPTION"
                     imageName="no_action.svg">
  </assessment-result>
  <section class="layout-content mt">
    <p>{{'NO_ACTION_SECURITY_RISK'  | translate}}</p>
  </section>
  <section class="layout-content mt">
    <button type="button" class="btn btn-secondary btn-lg btn-wide"
            (click)="onWorkshopSearch()">{{'WORKSHOP_SEARCH' | translate}}</button>
  </section>
  <assessment-text-link class="layout-content mt"></assessment-text-link>
</div>
